<hw-page-header class="page-header sticky" header="{{ 'mdm.obs-group-02.header' | translate }}">
  <div class="content float-right">
    <hw-button [loading]="saving" (click)="save()">{{ 'core.btn.save' | translate }}</hw-button>
    <hw-dropdown>
      <a *hwDropdownItem (click)="exportObservationGroup()">
        <i class="dropdown-menu-icon" nz-icon nzType="download" nzTheme="outline"></i>
        {{ 'mdm.obs-group-02.export' | translate }}
      </a>
    </hw-dropdown>
  </div>
</hw-page-header>

<nz-content class="main" *ngIf="observationGroup">
  <form #form="ngForm">
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="code" label="mdm.obs-group-02.code" required>
          <input nz-input name="code" [(ngModel)]="observationGroup.code" required />
        </hw-form-item>
        <hw-form-item name="names" label="mdm.obs-group-02.names" required>
          <hw-multilang-input name="names" [(ngModel)]="observationGroup.names" required></hw-multilang-input>
        </hw-form-item>

        <form #tableForm="ngForm" class="row-table">
          <hw-flex-editable-table
            header="mdm.obs-group-02.definitions"
            [data]="observationGroup.definitions"
            [rowInstance]="defaultRow"
            [form]="tableForm">
            <hw-flex-editable-column title="mdm.obs-group-02.observation" name="definition">
              <ng-template #viewTemplate let-row>
                {{ row.definition.names | localName }}
              </ng-template>
              <ng-template #editTemplate let-row>
                <hw-observation-definition-select
                  name="definition"
                  [(ngModel)]="row.definition"
                  required></hw-observation-definition-select>
              </ng-template>
            </hw-flex-editable-column>

            <hw-flex-editable-column title="mdm.obs-group-02.order" name="order">
              <ng-template #viewTemplate let-row>
                {{ row.priority }}
              </ng-template>
              <ng-template #editTemplate let-row>
                <hw-input-number name="order" min="0" [(ngModel)]="row.priority" required></hw-input-number>
              </ng-template>
            </hw-flex-editable-column>

            <hw-flex-editable-column title="mdm.obs-group-02.age-groups" name="age">
              <ng-template #viewTemplate let-row>
                <div *ngFor="let age of row.ageGroups">{{ age | localizedConceptName : 'age-group' | async }}</div>
              </ng-template>
              <ng-template #editTemplate let-row>
                <hw-concept-select
                  name="age"
                  [(ngModel)]="row.ageGroups"
                  [multiple]="true"
                  codesystem="age-group"
                  valueType="primitive"></hw-concept-select>
              </ng-template>
            </hw-flex-editable-column>
          </hw-flex-editable-table>
        </form>
      </div>
    </hw-form-row>
  </form>
</nz-content>
